import styled from 'styled-components';
import { HelperProps, helperStyles } from '../../const/helpers';

const BoxStyled = styled.div`
  ${(props: HelperProps) => helperStyles(props)}
`;

export default BoxStyled;
